import React, { useState, useEffect, useContext } from "react";
import Button from "../components/Button.js";
import Loader from "../components/Loader";
import { CacheContext } from "../contexts/CacheContext";
import "../styles/pages/_Gallery.scss";

const categories = [
  { name: "Portraits", query: "portrait photography" },
  { name: "Nature", query: "nature landscape" },
  { name: "Weddings", query: "wedding photography" },
  { name: "Urban", query: "city street photography" },
  { name: "Animals", query: "wildlife animal" },
  { name: "Travel", query: "travel photography" },
];

const Gallery = () => {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const { cache, setCachedData } = useContext(CacheContext);

  useEffect(() => {
    const fetchAlbums = async () => {
      if (cache.galleryAlbums) {
        setAlbums(cache.galleryAlbums);
        setLoading(false);
        return;
      }

      try {
        const fetchedAlbums = await Promise.all(
          categories.map(async (category) => {
            const response = await fetch(
              `https://api.unsplash.com/search/photos?query=${category.query}&per_page=8&client_id=xIVYxkrz6cl6LjI_THMykrl0yDcXP9UQWt6SdM2ydEM`
            );
            const data = await response.json();
            return {
              title: category.name,
              images: data.results || [],
            };
          })
        );
        setAlbums(fetchedAlbums);
        setCachedData("galleryAlbums", fetchedAlbums);
      } catch (error) {
        console.error("Error fetching albums:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlbums();
  }, [cache.galleryAlbums, setCachedData]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="gallery-page">
      <h1 className="gallery-title">Photographer’s Gallery</h1>
      <p className="gallery-subtitle">
        Browse albums by category — each one tells its own story.
      </p>

      <div className="album-masonry">
        {albums.map((album, i) => (
          <div key={i} className="album-card">
            <div className="album-preview">
              {album.images.slice(0, 5).map((img) => (
                <div key={img.id} className="album-preview-item">
                  <img
                    src={img.urls.small}
                    alt={img.alt_description || album.title}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>

            <div className="album-info">
              <h2>{album.title}</h2>
              <Button
                round
                to={`/gallery/${album.title.toLowerCase()}`}
                className="view-album-button"
              >
                View Album →
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
